'use client';

import { useState } from 'react';

import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma „Notice · Biocide“ (60145:13279, mobile 60459:102710): bg/warning-subtle card (radius 18)
 * with a 1 px border/warning outline, warning icon, text in DLZ/Body/S Medium and a close button
 * that hides it for this visit.
 */
export function ProductNotice({ text, className }: { text: string; className?: string }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div
      role="note"
      data-section="product-notice"
      className={cn(
        'flex items-center gap-3 rounded-[18px] border border-[#F6D592] bg-[#FEF6E7] p-4 sm:px-6',
        className,
      )}
    >
      <Icon name="warning" size={24} className="shrink-0 text-[#C27A05]" />
      <p className="dlz-body-s-medium min-w-0 flex-1 text-[#0F1012]">{text}</p>
      <button
        type="button"
        aria-label="Zavrieť upozornenie"
        onClick={() => setDismissed(true)}
        className="shrink-0 rounded-sm text-[#9096A0] transition-colors hover:text-[#0F1012] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012]"
      >
        <Icon name="x" size={20} />
      </button>
    </div>
  );
}
